// components/ClipboardMonitor.tsx
import React from 'react';
import { useClipShare } from '../hooks/useClipShare';
import { useLanguage } from '../context/LanguageContext';

export const ClipboardMonitor: React.FC = () => {
  const { clipboardMonitorActive, toggleClipboardMonitor, chatMode, setChatMode } = useClipShare();
  const { t } = useLanguage();

  return (
    <div className="clipboard-monitor">
      <div className="monitor-controls">
        <div className="mode-selector-small">
          <button 
            className={`mode-btn-small ${chatMode === 'auto' ? 'active' : ''}`}
            onClick={() => setChatMode('auto')}
          >
            {t.autoTracking}
          </button>
          <button 
            className={`mode-btn-small ${chatMode === 'manual' ? 'active' : ''}`}
            onClick={() => setChatMode('manual')}
          >
            {t.manualChat}
          </button>
        </div>
        
        {chatMode === 'auto' && (
          <div className="monitor-status">
            <span>{clipboardMonitorActive ? '👁️' : '⏸️'}</span>
            <span>{clipboardMonitorActive ? t.watchingClipboard : t.monitoringPaused}</span>
            <button 
              className="btn btn-secondary btn-small" 
              onClick={toggleClipboardMonitor}
            >
              {clipboardMonitorActive ? t.pause : t.start}
            </button>
          </div>
        )}
        
        {chatMode === 'manual' && (
          <div className="monitor-status">
            <span>💬</span>
            <span>{t.manualMode}</span>
          </div>
        )}
      </div>
    </div>
  );
};
